import { HTTPClient } from "./Client";

const SistemaApi = {
    async ObterTodosSistemasAtivos() {
        try {
            const response = await HTTPClient.get(`/Sistema/obterTodosSistemasAtivos`);
            return response.data;
        } catch (error) {
            console.error("Erro ao obter todos os sistemas:", error);
            throw error;
        }
    },

    async ObterTodosSistemasInativos() {
        try {
            const response = await HTTPClient.get(`Sistema/obterTodosSistemasDesativos`);
            return response.data;
        } catch (error) {
            console.error("Erro ao obter os sistemas inativis: ", error);
            throw error;
        }
    },

    async AdicionarSistema(sistema) {
        try {
            const novoSistema = {
                Nome: sistema.nome,
                Descricao: sistema.descricao,
                Url: sistema.url
            }
            const response = await HTTPClient.post(`/Sistema/adicionarSistema`, novoSistema);
            return response.data;
        } catch (error) {
            console.error("Erro ao cadastrar sistema: ", error);
            throw error;
        }
    },

    async DesativarSistema(id) {
        try {
            const response = await HTTPClient.put(`/Sistema/desativarSistema/${id}`);
            return response.data;
        } catch (error) {
            console.error("Erro ao desativar sistema:", error);
            throw error;
        }
    },

    async AtualizarSistema(sistema) {
        try {
            const response = await HTTPClient.put(`/Sistema/atualizarSistema/${sistema.id}`, sistema);
            return response.data;
        } catch (error) {
            console.error("Erro ao atualizar sistema:", error);
            throw error;
        }
    },

    async ObterSistema(id) {
        try {
            const response = await HTTPClient.get(`/Sistema/obterSistema/${id}`);
            return response.data;
        } catch (error) {
            console.error("Erro ao obter sistema:", error);
            throw error;
        }
    },
    
    async ListarSistemasComPaginacaoAsync(pagina, nome, descricao) {
                                
        const sistemasComPaginacao = {
            Pagina: pagina,
            Nome: nome,
          Descricao: descricao
        };

        const response = await HTTPClient.post(`/Sistema/ListarSistemasComPaginacao`, sistemasComPaginacao);

        return response.data;
    },
}

export default SistemaApi;